import { makeStyles } from 'tss-react/mui';

export const useSkeletonStyles = makeStyles()((theme) => ({
    container: {
        flex: 1,
    },
}));